export class StyleVariables {

  public fontFamily: string = '';
  public primaryColor: string = '#262626'
  public secondaryColor: string = '#999999';
  public defaultColor: string = '#515151';
  public baseColor: string = '#484848';
  public backgroundColor: string = '#ffffff';
  public cardBackgroundColor: string = '#f8f8f8';
  public headerTextColor: string = '#484848';
  public headerBackgroundColor: string = '';
  public topHeaderTextColor: string = '#484848';
  public topHeaderBackgroundColor: string = '';
  public headerFontFamily: string = '';
  public footerColor: string = '#fffffff';
  public footerSecColor: string = '';
  public footerTextColor: string = '#484848';
}


